import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { VESSEL_ARRIVAL_LABEL, VESSEL_DEPARTURE_LABEL } from '@core/configs/label';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from '__services';
import { cloneDeep, isEmpty } from 'lodash';
import { Subject } from 'rxjs';
import { Constants } from '~/app/core/configs/constants';

export type TInputInfo = {
  showModal?: boolean;
  code1?: string;
  code2?: string;
  vesselType?: number;
  index?: number;
  order?: number;
};

@Component({
  selector: 'app-vessel-locode',
  templateUrl: './vessel-locode.component.html',
  styleUrls: ['./vessel-locode.component.scss'],
})

export class VesselLocodeComponent implements OnDestroy {
  @Input() set data(value: TInputInfo) {
    this.inputInfo = cloneDeep(value);
    this.init();
  }
  @Output() cancel: EventEmitter<any> = new EventEmitter<any>();
  @Output() saveSuccess: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalContent') modalContent: ElementRef;
  modalFileRef: NgbModalRef;
  form: FormGroup;
  saving: boolean = false;
  private destroy$: Subject<any> = new Subject();
  inputInfo: TInputInfo;
  label: any = {};
  labelArrival: any = VESSEL_ARRIVAL_LABEL;
  labelDeparture: any = VESSEL_DEPARTURE_LABEL;
  polLocodes: Array<any> = [];
  polLocodesHasMore: boolean = false;
  podLocodes: Array<any> = [];
  podLocodesHasMore: boolean = false;
  locodesDefaultParams = Constants.locodesDefaultParams;
  // hasMoreLocode = false;

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private adminService: AdminService
  ) {}

  get code1(): AbstractControl {
    return this.form.get('code1');
  }

  get code2(): AbstractControl {
    return this.form.get('code2');
  }

  get name1(): AbstractControl {
    return this.form.get('name1');
  }

  get name2(): AbstractControl {
    return this.form.get('name2');
  }

  get country1(): AbstractControl {
    return this.form.get('country1');
  }

  get country2(): AbstractControl {
    return this.form.get('country2');
  }

  init(): void {
    if (!this.form) {
      this.initAddFileForm();
    }
    if (!isEmpty(this.inputInfo)) {
      this.label = this.labelArrival;
      this.initFieldsValue(this.inputInfo.code1, 'code1', 'name1', 'country1', 'polLocodes');
      this.initFieldsValue(this.inputInfo.code2, 'code2', 'name2', 'country2', 'podLocodes');
      if (this.inputInfo.vesselType === 1) {
        this.label = this.labelDeparture;
      }
      if (this.inputInfo.showModal) {
        this.openModal();
      }
    }
  }

  initAddFileForm() {
    this.form = this.fb.group({
      code1: [null, Validators.required],
      code2: [null, Validators.required],
      name1: [null, Validators.required],
      name2: [null, Validators.required],
      country1: [null, Validators.required],
      country2: [null, Validators.required],
    });
  }

  initFieldsValue(code, codeField, nameField, countryField, fieldAssign) {
    if(code) {
      this[codeField].setValue(code);
      this.onNextPortSearch({term: code}, fieldAssign, (res) => {
        if (res.length === 1) {
          this.onValueChanged(nameField, countryField, res[0]);
        }
      })
    }
  }

  onSave() {
    if (this.form.invalid) {
      return;
    }
    let data: Object = {...this.inputInfo, ...this.form.getRawValue()};
    this.saveSuccess.emit(data);
    this.modalFileRef.close();
  }

  openModal() {
    this.modalFileRef = this.modalService.open(this.modalContent, {
      centered: true,
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });
  }

  onCancel() {
    this.modalFileRef.close();
  }

  getLocodes(param = this.locodesDefaultParams, fieldAssign: string, append = false, calback?): void {
    this.adminService.getLocodes(param).subscribe((res) => {
      if (append) {
        this[fieldAssign] = [...this[fieldAssign], ...res?.data];
      } else {
        this[fieldAssign] = res?.data;
      }
      this[`${fieldAssign}HasMore`] = res?.has_more;
      // this.hasMoreLocode = res?.has_more;
      if (calback) {
        calback(res?.data);
      }
    });
  }

  onNextPortScrollToEnd(fieldAssign: string): void {
    const limit = 100;
    const offset = this[fieldAssign].length;
    if (this[`${fieldAssign}HasMore`]) {
      this.getLocodes({ ...this.locodesDefaultParams, offset, limit }, fieldAssign, true);
    }
  }

  onNextPortSearch(ev: { term: string }, fieldAssign: string, callback?): void {
    this.getLocodes({
      ...this.locodesDefaultParams,
      where: { code: { ilike: `${ev.term}%` } },
    }, fieldAssign, false, callback);
  }

  onDropdownClear(fieldAssign: string): void {
    this.getLocodes(this.locodesDefaultParams, fieldAssign, false);
  }

  onValueChanged(name, country, event): void {
    this[name].setValue(event?.name ?? null);
    this[country].setValue(event?.country?.name ?? null);
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
